'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _contextTypes = require('./contextTypes');

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _createTranslator = require('./createTranslator');

var _createTranslator2 = _interopRequireDefault(_createTranslator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides 't' function to those child components which are wrapped with 'withTranslator' decorator
 * @returns {React.Element<*>} A react element
 */
var TranslatorProvider = function (_React$Component) {
    (0, _inherits3.default)(TranslatorProvider, _React$Component);

    function TranslatorProvider() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TranslatorProvider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TranslatorProvider.__proto__ || (0, _getPrototypeOf2.default)(TranslatorProvider)).call.apply(_ref, [this].concat(args))), _this), _this.t = _this.props.translations && (0, _createTranslator2.default)(_this.props.translations), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(TranslatorProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                t: this.t
            };
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(_ref2) {
            var translations = _ref2.translations;

            this.t = translations && (0, _createTranslator2.default)(translations);
        }
    }, {
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {}, void 0, this.props.children);
        }
    }]);
    return TranslatorProvider;
}(_react2.default.Component);

TranslatorProvider.childContextTypes = _contextTypes2.default;
exports.default = TranslatorProvider;
//# sourceMappingURL=TranslatorProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-translations/dist/main/TranslatorProvider.js
// module id = 625
// module chunks = 0